/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { NonWidgetPage } from './non-widget-page-base';
import { iamLogin, iamUtils } from '../main';
import { iamLocalization } from '../localization';
import { iam } from '../iam';

export class SignInHelpPage extends NonWidgetPage {
  public override localize(): void {
    super.localize();
    iamLocalization.addLocalization(() => {
      iamLogin.localizeElement('pageTitle', 'resetPassword');
      iamLogin.localizeElement('main-header', {
        stringKey: 'passwordReset',
        stringParameters: { lineBreak: '<br>' },
        rawHTML: true
      });
      iamLogin.localizeElement(this.elements.getSubmitButton(), { stringKey: 'ok', isWidgetElement: true });
      if (iamLogin.pageInitialized) {
        iamLogin.localizeElement('login_hint', { attribute: 'placeholder', stringKey: 'primaryAuthUsernamePlaceHolder' });
      }
      iamLogin.localizeElement(document.querySelector('label[for=login_hint]'), { stringKey: 'email', isWidgetElement: true });
      iamLogin.localizeElement('signInBack', 'signinBack');
    });
  }

  public override initialize(): void {
    iamLogin.addLangOptions();
    // sign in page doesn't have asynchronous initialization, so just do all the initialization in initializeSignInHelpPseudoWidget()
    iamLogin.handleErrors();

    if (iam.settings.debug) console.log('initializing sign in help widget');
    iamLogin.showWidget();
  
    document.forms.namedItem('emailForm').onsubmit = event => {
      const email = iamLogin.getEmailFormValue();
      if (iamLogin.isEmailAddressValid(email)) {
        // submitting: reactivating or resetting password
        window.localStorage.setItem('login_hint', email);
        iamLogin.showTransitioningWidgetPage();
  
        const uamActivationEmailURL = iam.settings.usersURL + '/' + email + '/signin-help';
  
        const xmlhttp = new XMLHttpRequest();
  
        xmlhttp.onreadystatechange = () => {
          if (xmlhttp.readyState === XMLHttpRequest.DONE) {
            if (xmlhttp.status === 200) {
              if (iam.settings.debug) console.log('XMLHttpRequest', xmlhttp);
              if (iam.settings.debug) console.debug('status is ' + xmlhttp.status);
  
              if (xmlhttp.responseText && xmlhttp.responseText === '"User Locked Out"') {
                // account locked - can't proceed
                iamLogin.showErrorMessageLocalizable('accountLocked');
              } else {
                // success - let user know and change button to take the user back to email page
                iamLogin.registerLocalizationCallback(() => {
                  iamLogin.localizeElement('main-header', 'passwordForgotEmailSentTitle');
                  iamLogin.localizeElement('done-message', 'passwordForgotEmailSentDesc');
                  iamLogin.localizeElement(this.elements.getSubmitButton(), { attribute: 'value', stringKey: 'takeMeBackToLogin' });
                });
                document.getElementById('right-pane-contents').classList.add('allDone');
                document.getElementById('done-message').style.display = '';
                document.forms.namedItem('emailForm').onsubmit = () => {
                  // "take me back to login"
                  iamLogin.showTransitioningWidgetPage();
                  iam.Token.setLocation('email.html');
                  return false;
                };
              }
            } else {
              console.debug('status is ' + xmlhttp.status);
              iamLogin.showErrorMessageLocalizable('requestFailed');
            }
            iamLogin.unshowTransitioningWidgetPage();
          }
        };
        xmlhttp.open('POST', uamActivationEmailURL, true);
        xmlhttp.send();
      } else {
        iamLogin.showErrorMessageLocalizable('validEmail');
      }
      event.stopImmediatePropagation(); // since the submit won't take place, prevent other submit handlers from running, e.g. don't call hideMessageBanners()
      return false;
    };
  
    iamLogin.setEmailFormValue(iamLogin.parseQuery(iam.Token.getLocation().search).login_hint || window.localStorage.getItem('login_hint'));
  
    document.getElementById('signInBack').addEventListener('click', event => {
      return iamLogin.signInBack(event);
    });
  
    document.getElementById('loading-content').style.display = 'none';
    document.getElementById('right-pane-contents').style.display = '';
    document.getElementById('login_hint').focus();
    this.showCommonFields(['post-okta']);
    this.initializeCommon();
    this.initializePseudoWidgetCommon();
  }
  
  public override validateForm() {
    // disable submit button if the value isn't a valid email address
    this.elements.getSubmitButton().disabled = !iamLogin.isEmailAddressValid(iamLogin.getEmailFormValue());
  }
}
